import { useCallback, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { useSearchParams } from "react-router";

import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import Box from "ds/components/Box";
import CardWrapper from "ds/components/Card/components/Wrapper";
import CardHeader from "ds/components/Card/components/Header";
import CardContent from "ds/components/Card/components/Content";
import useTitle from "hooks/useTitle";

import { showCertificateDetailsDrawer } from "./CertificateDetailsDrawer";
import MissionControlCertificateTile from "./CertificateTile";
import MissionControlMissionsProgress from "./MissionsProgress";
import MissionControlMissionsProgressDropdown from "./MissionsProgress/Dropdown";
import useMissionControlData from "./useData";
import styles from "./styles.module.css";

const SKELETON_TILES = Array.from({ length: 4 }, (_, i) => i);

const MissionControl = () => {
  useTitle("Mission control");

  const { groups, loading } = useMissionControlData();
  const [searchParams, setSearchParams] = useSearchParams();
  const certificateId = searchParams.get("certificate");

  const cleanupCertificateParam = useCallback(() => {
    setSearchParams((prev) => {
      prev.delete("certificate");
      return prev;
    });
  }, [setSearchParams]);

  useEffect(() => {
    if (!certificateId || loading) return;

    const group = groups.find((g) => g.certificate?.id === certificateId);

    if (group?.certificate) {
      showCertificateDetailsDrawer({
        certificateId: group.certificate.id,
        onClose: cleanupCertificateParam,
      });
    }
  }, [certificateId, loading, groups, cleanupCertificateParam]);

  return (
    <>
      <ViewHeader>
        <ViewHeaderTitle>Mission control</ViewHeaderTitle>
      </ViewHeader>

      <Box
        surfaceColor="quaternary"
        direction="column"
        grow="1"
        fullHeight
        className={styles.scrollContainer}
      >
        <Box grid className={styles.layout}>
          <CardWrapper>
            <CardHeader titleTag="h2">Certifications</CardHeader>
            <CardContent hasHeader className={styles.certificatesGrid} grid gap="x-large">
              {loading && !groups.length
                ? SKELETON_TILES.map((i) => <Skeleton key={i} className={styles.skeletonTile} />)
                : groups.map((group) => (
                    <MissionControlCertificateTile key={group.id} group={group} />
                  ))}
            </CardContent>
          </CardWrapper>

          <Box direction="column" className={styles.rightSection}>
            <MissionControlMissionsProgress
              headerSuffix={<MissionControlMissionsProgressDropdown />}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default MissionControl;
